import React from 'react'
import WriterLabel from './WriterLabel/index'
import { observer } from 'mobx-react'
import { WriterModel } from '@Entities/work/writer-model'

interface WriterLabelsProps {
    linkedWriters: WriterModel[]
    isAmendable: boolean
    removeWriter(removingWriter: WriterModel): void
}

const WriterLabels = (props: WriterLabelsProps) => {
    const { linkedWriters } = props
    return (
        <>
            {linkedWriters.map((linkedWriter: WriterModel, index: number) => (
                <WriterLabel key={index} linkedWriter={linkedWriter} {...props} />
            ))}
        </>
    )
}
export default observer(WriterLabels)
